import React from 'react';
import { Link } from 'react-router-dom';
import { message, Table, Tabs, Radio, Button, Popover, Popconfirm, Modal, Form, Pagination, Row, Col, Icon, Input, Select, DatePicker, Spin } from 'antd';
const FormItem = Form.Item;
import { onFieldsChange, getUserGroups, changeUserGroup, getUsers, addUserGroup, modalStatus, editUserGroup, delUserGroup } from './actions';
import { connect } from 'react-redux';
import constant, { decode, encode } from './constant';
import moment from 'moment';
import ReactEcharts from 'echarts-for-react';


//todo 必传参数的校验不生效 
class UserGroupList extends React.Component {

    constructor(props) {
        super(props);
        this.handlePaginationChange = this.handlePaginationChange.bind(this);
        this.handleOnFieldsChange = this.handleOnFieldsChange.bind(this);
        this.handleUserGroup = this.handleUserGroup.bind(this);
    }

    componentDidMount() {
        this.props.getUserGroups();//查询用户组
    }

    componentWillUnmount() {
        let _serach = this.props.search;
        let _obj = {}
        Object.keys(_serach).forEach((key, index) => {
            _obj[key] = '';
        });
        this.props.onFieldsChange(Object.assign(_obj, { page: 1, pageSize: 10 }));
        this.props.changeUserGroup({ name: '', desc: '', users: [] });
    }

    handleOnFieldsChange(fields) {
        let _obj = {}
        Object.keys(fields).forEach((key, index) => {
            _obj[key] = fields[key].value;
        });
        this.props.onFieldsChange(Object.assign(_obj));
    }

    handleUserGroup(fields) {
        let userGroup = {}
        Object.keys(fields).forEach((key, index) => {
            userGroup[key] = fields[key].value;
        });
        this.props.changeUserGroup(Object.assign(userGroup));
    }


    handlePaginationChange(page, per_page) {
        this.props.onFieldsChange({ page: page, pageSize: per_page });
        this.props.getUserGroups();
    }

    handleEdit(record) {
        this.props.changeUserGroup(decode(record));
        this.props.modalStatus({ disabled: false, visible: true, type: 'edit' });
        this.props.getUsers();//查询没有群组的用户
    }

    async handleDelete(record) {
        await this.props.delUserGroup(record);
        await this.props.getUserGroups();
    }

    render() {
        let columns = [{
            title: '用户组名称',
            dataIndex: 'name',
        }, {
            title: '用户组描述',
            dataIndex: 'desc',
        }, {
            title: '创建时间',
            dataIndex: 'createTime',
            render: (text, record, index) => {
                return moment(text * 1000).format('YYYY-MM-DD HH:mm:ss');
            },
        }, {
            title: '用户组成员',
            dataIndex: 'users',
            render: (users) => {
                let content = (
                    <div>
                        {users ? users.map((v, k) => {
                            return <p>{v.name}</p>;
                        }) : ''}
                    </div>
                );
                return (
                    <div>
                        {users
                            ? users
                                .filter((item, index) => index < 2)
                                .map((v, k) => {
                                    return <p>{v.name}</p>;
                                })
                            : ''}
                        {users && users.length > 2 ? (
                            <Popover content={content} title="成员列表">
                                <a type="primary">...</a>
                            </Popover>
                        ) : ('')}
                    </div>
                );
            },
        }, {
            title: '操作',
            key: 'action',
            render: record => (
                <div>
                    <a onClick={this.handleEdit.bind(this, record)} >修改</a>
                    <span className="ant-divider" />
                    <Popconfirm title="是否删除?" onConfirm={this.handleDelete.bind(this, record)} >
                        <a href="#">删除</a>
                    </Popconfirm>
                </div>),
        }];
        const { userGroups, loading, search, visible } = this.props;
        const { total } = search;
        return (
            <div>
                <SearchForm
                    {...this.props}
                    handleOnFieldsChange={this.handleOnFieldsChange}
                />
                <UserGroupForm
                    {...this.props}
                    handleUserGroup={this.handleUserGroup}
                />
                <Spin spinning={loading} tip="加载中">
                    <Table columns={columns} dataSource={userGroups} pagination={false} bordered />
                    <Pagination
                        total={total}
                        className='ant-table-pagination'
                        onChange={this.handlePaginationChange}
                    />
                </Spin>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    loading: state.userGroup.loading,
    search: state.userGroup.search,
    userGroups: state.userGroup.userGroups,
    users: state.userGroup.users,
    userGroup: state.userGroup.userGroupData,
    modal: state.userGroup.modal,
});

const mapDispatchToProps = dispatch => ({
    onFieldsChange: (search) => dispatch(onFieldsChange(search)),
    getUserGroups: () => dispatch(getUserGroups()),
    changeUserGroup: (userGroup) => dispatch(changeUserGroup(userGroup)),
    getUsers: () => dispatch(getUsers()),
    addUserGroup: () => dispatch(addUserGroup()),
    modalStatus: (modal) => dispatch(modalStatus(modal)),
    editUserGroup: () => dispatch(editUserGroup()),
    delUserGroup: (record) => dispatch(delUserGroup(record)),
});

export default connect(mapStateToProps, mapDispatchToProps)(UserGroupList);

class Search extends React.Component {

    constructor(props) {
        super(props);
        this.handleReset = this.handleReset.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleAdd = this.handleAdd.bind(this);
    }

    handleReset() {
        this.props.form.resetFields();
    }

    //查询
    handleSearch(e) {
        e.preventDefault();
        this.props.getUserGroups();
    }

    handleAdd() {
        this.props.changeUserGroup({ _id: undefined, users: [] });
        this.props.modalStatus({ disabled: true, visible: true, type: 'add' });
        this.props.getUsers();//查询没有群组的用户
    }

    render() {
        const { getFieldDecorator } = this.props.form;
        return (
            <div >
                <h2 style={{ marginBottom: '20px' }}>用户群组管理</h2>
                <Form inline={true} onSubmit={this.handleSearch} className="searchWrapper">
                    <Row style={{ marginBottom: '20px' }}>
                        <FormItem label='用户组名称' >
                            {getFieldDecorator('name')(
                                <Input style={{ width: 200 }} placeholder='' />
                            )}
                        </FormItem>
                        <FormItem label='用户组描述' >
                            {getFieldDecorator('desc')(
                                <Input style={{ width: 200 }} placeholder='' />
                            )}
                        </FormItem>
                        <FormItem >
                            <Button type="primary" htmlType="submit">查询</Button>
                        </FormItem>
                        <FormItem >
                            <Button type="primary" onClick={this.handleAdd} >添加</Button>
                        </FormItem>
                    </Row>
                </Form>
            </div>
        )
    }
}
const SearchForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleOnFieldsChange(fields);
    }
})(Search);


class UserGroup extends React.Component {

    constructor(props) {
        super(props);
        this.modalClose = this.modalClose.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    modalClose() {
        this.props.modalStatus({ visible: false })
    }

    handleSubmit() {
        this.props.form.validateFields(async (err, fieldsValue) => {
            if (!err) {
                if (this.props.modal.type === 'add') {
                    await this.props.addUserGroup();
                    await this.props.getUserGroups();
                }
                if (this.props.modal.type === 'edit') {
                    await this.props.editUserGroup();
                    await this.props.getUserGroups();
                }
            }
        })
    }


    render() {
        const { userGroup, users, modal } = this.props;
        const { getFieldDecorator } = this.props.form;
        return (
            <Modal
                title="添加用户组"
                visible={modal.visible}
                okText="保存"
                onCancel={this.modalClose}
                onOk={this.handleSubmit}
                maskClosable={false}
            >
                <Form>
                    <FormItem label="用户组名称">
                        {getFieldDecorator('name', {
                            rules: [{ required: true, message: '用户组名称' }],
                        })(<Input placeholder="用户组名称" />)}
                    </FormItem>
                    <FormItem label="用户组描述" >
                        {getFieldDecorator('desc', {
                            rules: [{ required: true, message: '请填写用户组描述!' }],
                        })(<Input placeholder="用户组描述" />)}
                    </FormItem>
                    <FormItem label="用户组成员" >
                        {getFieldDecorator('users')(<Select
                            multiple
                            placeholder="用户组成员"
                            allowClear
                            optionFilterProp="children"
                            filterOption={(input, option) => option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
                            disabled={modal.disabled}
                        >
                            {users.filter((user, index) => {
                                return user.groupId ? false : true;
                            }).map((user, index) => {
                                return <Option key={user._id} id={user._id} value={user._id + ',' + user.name}>{user.name}</Option>
                            })}
                        </Select>)}
                    </FormItem>
                </Form>
            </Modal>
        )
    }

}
const UserGroupForm = Form.create({
    onFieldsChange(props, fields) {
        props.handleUserGroup(fields);
    },
    mapPropsToFields(props) {
        return {
            name: {
                value: props.userGroup.name
            },
            desc: {
                value: props.userGroup.desc
            },
            users: {
                value: props.userGroup.users
            }
        }
    }
})(UserGroup);




// WEBPACK FOOTER //
// ./pages/user/userGroup/index.js